import { Html } from '@react-three/drei';
import { LoadingAnimation as DefaultLoadingAnimation, MantineOverrideProvider } from '@uag/react-core';

interface LoadingAnimationProps {
    text: string;
}

export const LoadingAnimation = ({ text }: LoadingAnimationProps) => {
    return (
        <Html zIndexRange={[0, 0]} fullscreen>
            <MantineOverrideProvider>
                <div className="flex items-center justify-center h-full w-full bg-none">
                    <DefaultLoadingAnimation text={text} />
                </div>
            </MantineOverrideProvider>
        </Html>
    );
};
